<template>
  <div>
    <header>
      <div class="left">
        <h2>Resourcing</h2>
      </div>
    </header>
    <loading-indicator v-if="loadingData" class="loader" />
    <ResourcingTable v-else :interval-headers="intervalHeaders" :resources="resources"/>
  </div>
</template>

<script>
import ResourcingTable from "@/components/ResourcingTable";
import moment from "moment";
import API from '@/api'
import LoadingIndicator from "@/components/LoadingIndicator";

export default {
  name: 'Resourcing',
  components: {LoadingIndicator, ResourcingTable},
  data: () => ({
    loadingData: false,
    resources: {}
  }),
  mounted() {
    this.getOrganizationLoad();
  },
  methods: {
    getOrganizationLoad() {
      this.loadingData = true;
      API.getOrganizationLoad()
        .then(({data}) => {
          this.resources = data.organizationLoad;
        })
        .catch(e => {
          console.error(e);
        })
        .finally(() => {
          this.loadingData = false;
        })
    }
  },
  computed: {
    intervalHeaders() {
      const intervals = []
      const start = moment().startOf('month') // .startOf('year');
      for(let i = 0; i < 12; i++) {
        intervals.push(start.clone().add(i, 'month').format('DD-MM-YYYY'))
      }
      return intervals;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';
.loader {
  margin: 30px 0;
}
</style>
